import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, EmailField, BooleanField, DateField, FunctionField, SearchInput, SelectInput, useResourceContext, TopToolbar, ExportButton } from "react-admin";
import { Link, useLocation } from "react-router-dom";
import { cleanRangeChoices, formatPostalCode, getAllowance, getNameAndCompanyName, getStaffNum, isOverdue, monthChoices } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const CleanHistoryList = () => {
  const [requesters,setRequesters]=useState([]);
  let pumpingAmountTotal = 0;
  let pumpingWeighTotal = 0;
  let payTotal = 0;
  let taxPayTotal = 0;

 const resource = useResourceContext(); 

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/requesters/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setRequesters(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const customExporter = (records) => {
    let pumpingAmountTotal = 0;
    let pumpingWeighTotal = 0;
    let payTotal = 0;
    let taxPayTotal = 0;

    const excelData = records.map(record => {
      pumpingAmountTotal += record.pumpingAmount ?? 0;
      pumpingWeighTotal += record.pumpingWeigh ?? 0;
      payTotal += Math.floor((record.pumpingAmount ?? 0) * (record.pumpingPay ?? 0));
      taxPayTotal += Math.floor((record.pumpingAmount ?? 0) * (record.pumpingPay ?? 0) * 1.1);

      const user = requesters.find(req => req.id === record.requesterId);

      return {
        "管理業者": user ? getNameAndCompanyName(user.surname, user.name, user.companyName) : "",
        "清掃日": record.cleaningDate ? new Date(record.cleaningDate).toLocaleDateString() : "",
        "住所": `${record.postCode ?? ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`, 
        "顧客名": getNameAndCompanyName(record.surname, record.name, record.companyName),
        "規模": record.scale ?? "",
        "清掃範囲": record.cleanRange ? (cleanRangeChoices.find(choice => choice.id === record.cleanRange)?.name ?? "") : "",
        "汲取予定量(㎥)": record.pumpingAmount ? record.pumpingAmount.toLocaleString() : "",
        "汲取実量(㎥)": record.pumpingWeigh ? record.pumpingWeigh.toLocaleString() : "",
        "金額": (record.pumpingAmount && record.pumpingPay) ? (record.pumpingAmount * record.pumpingPay).toLocaleString() : "",
        "税込金額": (record.pumpingAmount && record.pumpingPay) ? Math.floor(record.pumpingAmount * record.pumpingPay * 1.1).toLocaleString() : "",
        "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
        "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
        "領収": record.isPay ? "済" : "",
        "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
        "担当者": `${record.staffName ?? ""}・${record.staffName2 ?? ""}`
      };
    });

    // 合計ラベル行
    excelData.push({
      "管理業者": "",
      "清掃日": "",
      "住所": "",
      "顧客名": "",
      "規模": "",
      "清掃範囲": "",
      "汲取予定量(㎥)": "汲取予定量合計(㎥)",
      "汲取実量(㎥)": "汲取実量合計(㎥)",
      "金額": "金額合計",
      "税込金額": "税込金額合計"
    });

    // 合計数値行
    excelData.push({
      "管理業者": "",
      "清掃日": "",
      "住所": "",
      "顧客名": "",
      "規模": "",
      "清掃範囲": "",
      "汲取予定量(㎥)": pumpingAmountTotal.toLocaleString(),
      "汲取実量(㎥)": pumpingWeighTotal.toLocaleString(),
      "金額": payTotal.toLocaleString(),
      "税込金額": taxPayTotal.toLocaleString()
    });

    // Excel用ワークシート作成
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // 列幅設定（必要に応じて調整）
    worksheet["!cols"] = [
      { wch: 20 }, // 管理業者
      { wch: 12 }, // 清掃日
      { wch: 60 }, // 住所
      { wch: 25 }, // 顧客名
      { wch: 10 }, // 規模
      { wch: 15 }, // 清掃範囲
      { wch: 15 }, // 汲取予定量(㎥)
      { wch: 15 }, // 汲取実量(㎥)
      { wch: 15 }, // 金額
      { wch: 20 }, // 税込金額
      { wch: 12 }, // 請求日
      { wch: 12 }, // 再発行日
      { wch: 5 },  // 領収
      { wch: 12 }, // 領収日
      { wch: 20 }  // 担当者
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "清掃履歴");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `清掃履歴_${new Date().toLocaleDateString()}.xlsx`);
};

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {
  //     pumpingAmountTotal += record.pumpingAmount ? record.pumpingAmount : 0;
  //     pumpingWeighTotal += record.pumpingWeigh ? record.pumpingWeigh : 0;
  //     payTotal += Math.floor(record.pumpingAmount*record.pumpingPay);
  //     taxPayTotal += Math.floor(record.pumpingAmount*record.pumpingPay*1.1);

  //     const user = requesters.find(req => req.id === record.requesterId)

  //     return {
  //       // "清掃No": String(record.number).padStart(5, "0"), 
  //       "管理業者": user ? `${getNameAndCompanyName(user.surname,user.name,user.companyName)}` : "",
  //       "清掃日": record.cleaningDate ? new Date(record.cleaningDate).toLocaleDateString() : "",
  //       "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
  //       "顧客名": `${getNameAndCompanyName(record.surname,record.name,record.companyName)}`, // フルネーム結合
  //       "規模": record.scale ?? "",
  //       "清掃範囲": record.cleanRange ? (cleanRangeChoices.find(choice => choice.id === record.cleanRange)).name : "",
  //       "汲取予定量(㎥)": record.pumpingAmount ? record.pumpingAmount.toLocaleString() : "",
  //       "汲取実量(㎥)": record.pumpingWeigh ? record.pumpingWeigh.toLocaleString() : "",
  //       "金額": (record.pumpingAmount && record.pumpingPay) ? `${(record.pumpingAmount*record.pumpingPay).toLocaleString()}` : "",
  //       "税込金額":(record.pumpingAmount && record.pumpingPay) ? `${(Math.floor(record.pumpingAmount*record.pumpingPay*1.1)).toLocaleString()}` : "",
  //       "請求日": record.invoiceDate ? new Date(record.invoice).toLocaleDateString() : "",
  //       "再発行日": record.reissue ? new Date(record.reissueDate).toLocaleDateString() : "",
  //       "領収": record.isPay ? "済" : "",
  //       "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
  //       "担当者": `${record.staffName ?? ""}・${record.staffName2 ?? ""}`
  //     }
        
  //   });

  //   csvData.push({
  //     // "清掃No":"",
  //     "管理業者":"",
  //     "清掃日":"",
  //     "住所":"",
  //     "顧客名":"",
  //     "規模":"",
  //     "清掃範囲":"",
  //     "汲取予定量(㎥)":`汲取予定量合計(㎥)`,
  //     "汲取実量(㎥)":`汲取実量合計(㎥)`,
  //     "金額":`金額合計`,
  //     "税込金額":`税込金額合計`
  //   });

  //   csvData.push({
  //     // "清掃No":"",
  //     "管理業者":"",
  //     "清掃日":"",
  //     "住所":"",
  //     "顧客名":"",
  //     "規模":"",
  //     "清掃範囲":"",
  //     "汲取予定量(㎥)":pumpingAmountTotal ? `${pumpingAmountTotal.toLocaleString()}` : "",
  //     "汲取実量(㎥)":pumpingWeighTotal ? `${pumpingWeighTotal.toLocaleString()}` : "",
  //     "金額":payTotal ? `${payTotal.toLocaleString()}` : "",
  //     "税込金額": taxPayTotal ? `${taxPayTotal.toLocaleString()}` : "",
  //   });
  
  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `清掃履歴_` + new Date().toLocaleDateString());
  // };
  
  const CustomerFilters = [
    <SearchInput
      source="q" 
      alwaysOn 
      placeholder="郵便番号・住所・顧客名" 
      inputProps={{ style: { fontSize: '12px' } }}
      sx={{ width: 250 }}
    />,
    <SelectInput
      source="month"
      label={<span style={{fontSize:"12px"}}>清掃月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" }, 
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
  <TopToolbar>
    <CustomCreateButton basePath="/cleanHistory"/>
    <ExportButton exporter={customExporter}/>
  </TopToolbar>
  );

  return (
    <List filters={CustomerFilters}  actions={<CustomersActions />}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false} rowStyle={(record) => isOverdue(record) ? { backgroundColor: "#FFCCCC" } : {}}>
        {/* <FunctionField source="number" label="清掃No" render={(record) => {
          return String(record.number).padStart(5, "0");
        }}/> */}
        <FunctionField
          source="requesterId"
          label="管理業者"
          render={(record) => {
            const user = requesters.find(req => req.id === record.requesterId)
            if(user){
              return <Link to={`/requesters/show/${record.requesterId}`}>{`${getNameAndCompanyName(user.surname,user.name,user.companyName)}`}</Link>;
            }
            
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <DateField source="cleaningDate" label="清掃日" />
        <FunctionField
          label="住所"
          render={record => {
            return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
          }}
        />
        <FunctionField label="顧客名"
          render={(record) => {
            return <Link to={`/customers-clean/show/${record.customerId}`}>{`${getNameAndCompanyName(record.surname,record.name,record.companyName)}`}</Link>;
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <TextField source="scale" label="規模" />
        <FunctionField
          label="清掃範囲"
          render={record => {
            const choice = cleanRangeChoices.find(choice => choice.id === record.cleanRange);
            return choice ? choice.name : ""; 
          }}
        />
        <FunctionField source="pumpingAmount" label="汲取予定量(㎥)" 
          render={record => {
            return `${record.pumpingAmount ? record.pumpingAmount.toLocaleString() : ""}`;
          }}
        />
        <FunctionField source="pumpingWeigh" label="汲取実量(㎥)" 
          render={record => {
            return `${record.pumpingWeigh ? record.pumpingWeigh.toLocaleString() : ""}`;
          }}
        />
        <FunctionField
          label="金額(消費税)"
          render={record => {
            return (record.pumpingAmount && record.pumpingPay) ? `${(record.pumpingAmount*record.pumpingPay).toLocaleString()}円(${(Math.floor(record.pumpingAmount*record.pumpingPay*0.1)).toLocaleString()})`: "";
          }}
        />
        <FunctionField
          label="税込金額"
          render={record => {
            return (record.pumpingAmount && record.pumpingPay) ?  `${(Math.floor(record.pumpingAmount*record.pumpingPay*1.1)).toLocaleString()}円` : "";
          }}
        />
        <FunctionField
          // label="請求No"
          label=""
          render={record => {
            // return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && String(record.invoiceNumber).padStart(5, "0")}</Link>;
            return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && <>請求</>}</Link>;
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <DateField source="invoiceDate" label="請求日" />
        <DateField source="reissueDate" label="再発行日" />
        <FunctionField
          label="領収"
          render={record => {
            return `${record.isPay ? "済" : ""}`;
          }}
        />
        <DateField source="receiptDate" label="領収日" />
        <FunctionField
          label="担当者" 
          render={record => {
            return `${record.staffName ?? ""}・${record.staffName2 ?? ""}`;
          }}
        />
        <FunctionField
          label="手当" 
          render={record => {
            return `${(getAllowance(record.pumpingAmount,getStaffNum(record))).toLocaleString()}`;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default CleanHistoryList;
